const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 26,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 1.32 20 2.64 20 4 C21.65 4 23.3 4 25 4 C25 9.94 25 15.88 25 22 C23.35 22 21.7 22 20 22 C20 23.32 20 24.64 20 26 C13.4 26 6.8 26 0 26 C0 24.68 0 23.36 0 22 C-1.65 22 -3.3 22 -5 22 C-5 16.06 -5 10.12 -5 4 C-3.35 4 -1.7 4 0 4 C0 2.68 0 1.36 0 0 Z M2 2 C2 2.66 2 3.32 2 4 C7.28 4 12.56 4 18 4 C18 3.34 18 2.68 18 2 C12.72 2 7.44 2 2 2 Z M-3 6 C-3 8.31 -3 10.62 -3 13 C5.58 13 14.16 13 23 13 C23 10.69 23 8.38 23 6 C14.42 6 5.84 6 -3 6 Z M-3 15 C-3 16.65 -3 18.3 -3 20 C-2.01 20 -1.02 20 0 20 C0 18.35 0 16.7 0 15 C-0.99 15 -1.98 15 -3 15 Z M2 15 C2 17.97 2 20.94 2 24 C7.28 24 12.56 24 18 24 C18 21.03 18 18.06 18 15 C12.72 15 7.44 15 2 15 Z M20 15 C20 16.65 20 18.3 20 20 C20.99 20 21.98 20 23 20 C23 18.35 23 16.7 23 15 C22.01 15 21.02 15 20 15 Z ",
    transform: "translate(5,0)",
    style: {
      fill: "rgb(108, 182, 227)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    transform: "translate(5,7)",
    style: {
      fill: "rgb(108, 182, 227)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 0.66 12 1.32 12 2 C8.04 2 4.08 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    transform: "translate(9,16)",
    style: {
      fill: "rgb(108, 182, 227)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C8 0.66 8 1.32 8 2 C5.36 2 2.72 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    transform: "translate(9,20)",
    style: {
      fill: "rgb(108, 182, 227)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPrint);
export default __webpack_public_path__ + "static/media/ico-print.3cd0749502d24e5f9a3a201a4e35b9f8.svg";
export { ForwardRef as ReactComponent };